"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cpUpdateFolder = exports.cpPreviewImage = exports.cpGetFolder = exports.cpGetAllcpRootNode = exports.cpGetAllInitialFolderChange = exports.cpGetAllInitialFolder = exports.cpGetAllFolder = exports.cpFolderSuccess = exports.cpFolderReset = exports.cpFolderPreviewReset = exports.cpFolderError = exports.cpFolderEdit = exports.cpFolderDetailsHtml = exports.cpFolderDetails = exports.cpFolderCreate = exports.cpDeleteFolder = void 0;
var _cpFolder = require("./cpFolder.constant");
// @flow

// common success
var cpFolderSuccess = function cpFolderSuccess(actionType, data) {
  return {
    type: _cpFolder.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.cpFolderSuccess = cpFolderSuccess;
var cpFolderError = function cpFolderError(actionType, error) {
  return {
    type: _cpFolder.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.cpFolderError = cpFolderError;
var cpFolderCreate = function cpFolderCreate(data) {
  return {
    type: _cpFolder.actionTypes.CREATE,
    payload: data
  };
};

/**
 * get folder
 * @param payload
 * @returns api response
 * @description this function used to create folder.
 */
exports.cpFolderCreate = cpFolderCreate;
var cpGetFolder = function cpGetFolder(data) {
  return {
    type: _cpFolder.actionTypes.GET_FOLDER,
    payload: data
  };
};

/**
 * update Folder
 * @param payload
 * @returns api response
 * @description this function used to update th folder.
 */
exports.cpGetFolder = cpGetFolder;
var cpUpdateFolder = function cpUpdateFolder(data) {
  return {
    type: _cpFolder.actionTypes.UPDATE_FOLDER,
    payload: data
  };
};

/**
 *  get all folder
 * @param payload
 * @returns api response
 * @description this function used to get all folder.
 */
exports.cpUpdateFolder = cpUpdateFolder;
var cpGetAllFolder = function cpGetAllFolder(data) {
  return {
    type: _cpFolder.actionTypes.GET_ALL_FOLDER,
    payload: data
  };
};

/**
 * get all Initial folder.
 * @param payload
 * @returns api response
 * @description this function used to get all Initial folder.
 */
exports.cpGetAllFolder = cpGetAllFolder;
var cpGetAllInitialFolder = function cpGetAllInitialFolder(data) {
  return {
    type: _cpFolder.actionTypes.GET_ALL_INITIAL_FOLDER,
    payload: data
  };
};

/**
 * get all Initial folder.
 * @param payload
 * @returns api response
 * @description this function used to get all Initial folder.
 */
exports.cpGetAllInitialFolder = cpGetAllInitialFolder;
var cpGetAllInitialFolderChange = function cpGetAllInitialFolderChange(data) {
  return {
    type: _cpFolder.actionTypes.GET_ALL_INITIAL_FOLDER_CHANGE,
    payload: data
  };
};

/**
 * get all cp root node
 * @param payload
 * @returns api response
 * @description this function used to get all cp root node.
 */
exports.cpGetAllInitialFolderChange = cpGetAllInitialFolderChange;
var cpGetAllcpRootNode = function cpGetAllcpRootNode(data) {
  return {
    type: _cpFolder.actionTypes.GET_ALL_CP_ROOT_NODE,
    payload: data
  };
};

/**
 * delete folder
 * @param payload
 * @returns api response
 * @description this function used to delete folder.
 */
exports.cpGetAllcpRootNode = cpGetAllcpRootNode;
var cpDeleteFolder = function cpDeleteFolder(data) {
  return {
    type: _cpFolder.actionTypes.DELETE_CP_FOLDER,
    payload: data
  };
};

/**
 * cp details folder
 * @param payload
 * @returns api response
 * @description this function used to cp details folder.
 */
exports.cpDeleteFolder = cpDeleteFolder;
var cpFolderEdit = function cpFolderEdit(data) {
  return {
    type: _cpFolder.actionTypes.CP_EDIT,
    payload: data
  };
};

/**
 * cp details folder
 * @param payload
 * @returns api response
 * @description this function used to cp details folder.
 */
exports.cpFolderEdit = cpFolderEdit;
var cpFolderDetails = function cpFolderDetails(data) {
  return {
    type: _cpFolder.actionTypes.CP_DETAILS,
    payload: data
  };
};

/**
 * cp details folder
 * @param payload
 * @returns api response
 * @description this function used to cp details folder html.
 */
exports.cpFolderDetails = cpFolderDetails;
var cpFolderDetailsHtml = function cpFolderDetailsHtml(data) {
  return {
    type: _cpFolder.actionTypes.CP_DETAILS_HTML,
    payload: data
  };
};

/**
 * cp details folder preview image
 * @param payload
 * @returns api response
 * @description this function used to cp details folder preview image.
 */
exports.cpFolderDetailsHtml = cpFolderDetailsHtml;
var cpPreviewImage = function cpPreviewImage(data) {
  return {
    type: _cpFolder.actionTypes.CP_PREVIEW_IMAGE,
    payload: data
  };
};

/**
 * resets
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.cpPreviewImage = cpPreviewImage;
var cpFolderReset = function cpFolderReset() {
  return {
    type: _cpFolder.actionTypes.RESET
  };
};

/**
 * resets
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.cpFolderReset = cpFolderReset;
var cpFolderPreviewReset = function cpFolderPreviewReset() {
  return {
    type: _cpFolder.actionTypes.RESET_PREVIEW
  };
};
exports.cpFolderPreviewReset = cpFolderPreviewReset;